import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import GetInTouch from '../Components/Contact/GetInTouch'
import BookATour from '../Components/Contact/BookATour'
import ContactMap from '../Components/Contact/ContactMap'
import ScrollToTop from '../Components/ScrollToTop'
import FooterOne from '../Components/Footer/FooterOne'

function Contact() {
    return (
        <>
            <Breadcrumb
                title='Contact Us'
            />
            <GetInTouch />
            <BookATour />
            <ContactMap />
            <ScrollToTop />
        </>
    )
}

export default Contact
